import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { XIcon } from 'lucide-react';
import { Pagination, Table, TD, TH, THead, TR } from '../components/ui/Table';
import { NotFound } from './NotFound';
import { addressById, shipmentByUuid } from '../data/shipments';
export function ShipmentDetail() {
  const {
    uuid
  } = useParams();
  const navigate = useNavigate();
  const shipment = shipmentByUuid(uuid);
  if (!shipment) return <NotFound data-id="element-599" data-mp="3mmy5szrokvcc" />;
  const address = addressById(shipment.addressId);
  return <>
      <header className="flex items-center gap-3 border-b border-ink-200 bg-white px-6 py-4" data-id="element-600" data-mp="3rkq8motv61vb">
        <button type="button" onClick={() => navigate('/shipments')} aria-label="Close shipment" className="rounded p-1 text-ink-500 hover:bg-ink-100 hover:text-ink-700" data-id="element-601" data-mp="85ccaj78tey">
          <XIcon className="h-4 w-4" data-id="element-602" data-mp="9678ocrzmxvw" />
        </button>
        <h1 className="text-[17px] font-bold text-ink-900" data-id="element-603" data-mp="e8g3leof8a0n">{shipment.id}</h1>
      </header>

      <div className="flex-1 bg-white px-6 py-5" data-id="element-604" data-mp="3a2h755cix1dz">
        <dl className="grid grid-cols-1 gap-4 rounded-lg bg-ink-50 px-5 py-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-605" data-mp="3a04h04wm3kpu">
          <div data-id="element-606" data-mp="355h0as7unult">
            <dt className="text-[12px] text-ink-500" data-id="element-607" data-mp="311982l26nwiu">Return Shipment Address</dt>
            <dd className="mt-1 text-[13px] font-medium text-ink-900" data-id="element-608" data-mp="313dlbtlz27vs">
              {address.location}, {address.address}
            </dd>
          </div>
          <div data-id="element-609" data-mp="3srf4sd71jhdi">
            <dt className="text-[12px] text-ink-500" data-id="element-610" data-mp="3srx97x3ux1wi">Addressee</dt>
            <dd className="mt-1 text-[13px] font-medium text-ink-900" data-id="element-611" data-mp="3oqvarihrktvl">{address.addressee}</dd>
          </div>
          <div data-id="element-612" data-mp="3jzd9etbtwra3">
            <dt className="text-[12px] text-ink-500" data-id="element-613" data-mp="3jyu0g245pd87">Phone</dt>
            <dd className="mt-1 text-[13px] font-medium text-ink-900" data-id="element-614" data-mp="3f23krfw9kjnb">{address.phone ?? '-'}</dd>
          </div>
          <div data-id="element-615" data-mp="gcd5foj7jsfo">
            <dt className="text-[12px] text-ink-500" data-id="element-616" data-mp="gcuyydehjsjw">Email</dt>
            <dd className="mt-1 break-words text-[13px] font-medium text-ink-900" data-id="element-617" data-mp="bk1tfnb70g6r">{address.email}</dd>
          </div>
        </dl>

        <div className="mt-6" data-id="element-618" data-mp="ui515vpregeh">
          <Table minWidth={980} data-id="element-619" data-mp="uiwvz4bj8a3p">
            <THead data-id="element-620" data-mp="zgga8488cmvn">
              <tr data-id="element-621" data-mp="zevhmk5h7e0f">
                <TH data-id="element-622" data-mp="zff1w7ilmehm">Device Make &amp; Model</TH>
                <TH data-id="element-623" data-mp="loryi21w80f7">Serial Number</TH>
                <TH data-id="element-624" data-mp="lnqq65c9hs16">Filing Date</TH>
                <TH data-id="element-625" data-mp="lmpcdt3v2rfr">School</TH>
                <TH data-id="element-626" data-mp="ppln6xn5tj95">Asset Tag ID</TH>
                <TH data-id="element-627" data-mp="pokc4t658wrf">Student Name</TH>
              </tr>
            </THead>
            <tbody data-id="element-628" data-mp="bq2qr23pnwco">
              {shipment.devices.map(device => <TR key={device.serialNumber} data-id="element-629" data-mp="gp5o00dg8ya3">
                  <TD data-id="element-630" data-mp="gr0a3i0giwfr">{device.makeModel}</TD>
                  <TD data-id="element-631" data-mp="2pnw3c4ux4wi">{device.serialNumber}</TD>
                  <TD data-id="element-632" data-mp="2qz7ny4jngy6">{device.filingDate}</TD>
                  <TD data-id="element-633" data-mp="6r9f7f7ziff5">{device.school}</TD>
                  <TD data-id="element-634" data-mp="6saobe5fwru8">{device.assetTagId}</TD>
                  <TD data-id="element-635" data-mp="6t2m8vmif1no">{device.studentName}</TD>
                </TR>)}
            </tbody>
          </Table>
          <Pagination page={1} totalPages={1} onChange={() => undefined} data-id="element-636" data-mp="2150lc4r3uh5u" />
        </div>
      </div>
    </>;
}